/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignStatusFromJSON, ApiCampaignStatusToJSON, } from './ApiCampaignStatus';
import { ApiCampaignTypeFromJSON, ApiCampaignTypeToJSON, } from './ApiCampaignType';
import { ApiPathStatusFromJSON, ApiPathStatusToJSON, } from './ApiPathStatus';
import { ApiSimplePersonalisationFromJSON, ApiSimplePersonalisationToJSON, } from './ApiSimplePersonalisation';
import { ApiSimpleProjectFromJSON, ApiSimpleProjectToJSON, } from './ApiSimpleProject';
import { ApiSimpleUserFromJSON, ApiSimpleUserToJSON, } from './ApiSimpleUser';
import { ApiSplitCampaignUrlFromJSON, ApiSplitCampaignUrlToJSON, } from './ApiSplitCampaignUrl';
export function ApiSimpleCampaignFromJSON(json) {
    return ApiSimpleCampaignFromJSONTyped(json, false);
}
export function ApiSimpleCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceIds': !exists(json, 'audienceIds') ? undefined : json['audienceIds'],
        'classificationItemIds': !exists(json, 'classificationItemIds') ? undefined : json['classificationItemIds'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'fallbackUrl': !exists(json, 'fallbackUrl') ? undefined : json['fallbackUrl'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lastUser': !exists(json, 'lastUser') ? undefined : ApiSimpleUserFromJSON(json['lastUser']),
        'maxNumberOfLeads': !exists(json, 'maxNumberOfLeads') ? undefined : json['maxNumberOfLeads'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'noCache': !exists(json, 'noCache') ? undefined : json['noCache'],
        'owner': !exists(json, 'owner') ? undefined : ApiSimpleUserFromJSON(json['owner']),
        'pathStatus': !exists(json, 'pathStatus') ? undefined : ApiPathStatusFromJSON(json['pathStatus']),
        'pending': !exists(json, 'pending') ? undefined : json['pending'],
        'personalisations': !exists(json, 'personalisations') ? undefined : (json['personalisations'].map(ApiSimplePersonalisationFromJSON)),
        'probability': !exists(json, 'probability') ? undefined : json['probability'],
        'project': !exists(json, 'project') ? undefined : ApiSimpleProjectFromJSON(json['project']),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'status': !exists(json, 'status') ? undefined : ApiCampaignStatusFromJSON(json['status']),
        'subdomainId': !exists(json, 'subdomainId') ? undefined : json['subdomainId'],
        'type': !exists(json, 'type') ? undefined : ApiCampaignTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'urls': !exists(json, 'urls') ? undefined : (json['urls'].map(ApiSplitCampaignUrlFromJSON)),
    };
}
export function ApiSimpleCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audienceIds': value.audienceIds,
        'classificationItemIds': value.classificationItemIds,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'description': value.description,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'fallbackUrl': value.fallbackUrl,
        'id': value.id,
        'lastUser': ApiSimpleUserToJSON(value.lastUser),
        'maxNumberOfLeads': value.maxNumberOfLeads,
        'name': value.name,
        'noCache': value.noCache,
        'owner': ApiSimpleUserToJSON(value.owner),
        'pathStatus': ApiPathStatusToJSON(value.pathStatus),
        'pending': value.pending,
        'personalisations': value.personalisations === undefined ? undefined : (value.personalisations.map(ApiSimplePersonalisationToJSON)),
        'probability': value.probability,
        'project': ApiSimpleProjectToJSON(value.project),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'status': ApiCampaignStatusToJSON(value.status),
        'subdomainId': value.subdomainId,
        'type': ApiCampaignTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'url': value.url,
        'urls': value.urls === undefined ? undefined : (value.urls.map(ApiSplitCampaignUrlToJSON)),
    };
}
